export default "__VITE_ASSET__BzIc$c3s__"